import { render } from "./NewPackage.vue?vue&type=template&id=53454328"
import script from "./NewPackage.vue?vue&type=script&lang=js"
export * from "./NewPackage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__